export default class SavedReportService {
  /** @ngInject **/
  constructor(
    _,
    $q,
    $http,
    ngAuthSettings,
    promiseCacheService,
    moment
  ) {
    this._ = _;
    this.$http = $http;
    this.$q = $q;
    this.moment = moment;
    this.ngAuthSettings = ngAuthSettings;
    this.promiseCacheService = promiseCacheService;
    this.savedReports = [];
    this.cacheKey = 'savedReports-';
  }

  saveReport(accountId, report) {
    this.#sanitizeReportObject(report);
    const me = this;
    var newReport = {
      name: report.name,
      settings: report
    };
    return this.$http.post(this.#getBaseUrl(accountId), newReport)
      .then(function (response) {
        me.savedReports.push(response.data.savedReport);
        return angular.copy(response.data.savedReport);
      });
  }

  updateReport(accountId, report) {
    this.#sanitizeReportObject(report);
    const me = this;
    const newReport = {
      name: report.name,
      settings: report
    };
    return this.$http.put(this.#getBaseUrl(accountId) + report.id, newReport)
      .then(function (response) {
        const index = me._.findIndex(me.savedReports, {id: report.id});
        if (index > -1) {
          me.savedReports.splice(index, 1, response.data.savedReport);
          me.promiseCacheService.clean(me.cacheKey + report.id);
        } else {
          me.savedReports.push(response.data.savedReport);
        }
        return angular.copy(response.data.savedReport);
      });
  }

  getReports(accountId) {
    const me = this;
    return this.$http.get(this.#getBaseUrl(accountId)).then(function(response){
      me.savedReports = me._.transform(response.data.savedReports, function(reports, report, i) {
        report.settings.id = report.id;
        reports[i] = report.settings;
      }, []);
      return me.savedReports;
    });
  }

  getReport(accountId, reportId) {
    const me = this;
    return this.promiseCacheService.getCallWithCachedPromise(this.cacheKey + reportId, this.#getBaseUrl(accountId) + reportId, 3600)
      .then(function (response) {
        var savedReportSettings = response.data.savedReport.settings;
        savedReportSettings.id = response.data.savedReport.id;
        me.#momentTimeRange(savedReportSettings);
        return savedReportSettings;
      }).catch(function(response){
        return me.$q.reject(response);
      });
  }

  deleteReport(accountId, reportId) {
    const me = this;
    return this.$http.delete(this.#getBaseUrl(accountId) + reportId).then(function(response){
      me._.remove(me.savedReports, {id: reportId});
      me.promiseCacheService.clean(me.cacheKey + reportId);
      return response.data;
    }).catch(function () {
      return me.$q.reject({ data: { message: 'Unable to delete saved report' } });
    });
  }

  #momentTimeRange (report) {
    if (report.settings.timeRange) {
      report.settings.timeRange.startDate = this.moment(report.settings.timeRange.startDate);
      report.settings.timeRange.endDate = this.moment(report.settings.timeRange.endDate);
    }
  }
  
  #sanitizeReportObject (report) {
    delete report.settings.callLogs;
    delete report.settings.reportTime;
  }
  
  #getBaseUrl (accountId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/savedReports/';
  }
}
